import React, { useContext } from 'react';
import { InfoContext } from '../../../context';
import { LanguageItem } from './LanguageItem';

export function LanguageMenuItems() {
	const { languages } = useContext(InfoContext);

	return (
		<>
			{languages.available.map((language) => {
				return <LanguageItem language={language} key={language.locale} />;
			})}
		</>
	);
}
